module.exports = __webpack_public_path__ + "img/vexCorpLogo.d0d98c75.png";